import type { AttributeDef } from '@flexiplanner/types';

export function parseAttributeOptions(attr: Pick<AttributeDef, 'options'>): string[] {
  if (!attr.options) return [];
  if (Array.isArray(attr.options)) return attr.options as unknown as string[];
  try {
    const parsed = JSON.parse(attr.options);
    if (Array.isArray(parsed)) return parsed.map(String);
  } catch {
    // Fall through to comma/newline separated legacy values.
  }
  return String(attr.options)
    .split(/[\n,]/)
    .map(option => option.trim())
    .filter(Boolean);
}

export function withAddedAttributeOption(attr: AttributeDef, option: string): AttributeDef {
  const clean = normalizeAttributeOption(option);
  if (!clean) return attr;
  const values = new Map<string, string>();
  for (const existing of parseAttributeOptions(attr)) {
    const normalized = normalizeAttributeOption(existing);
    if (normalized) values.set(normalized.toLowerCase(), normalized);
  }
  values.set(clean.toLowerCase(), clean);
  return {
    ...attr,
    data_type: 'enum',
    options: JSON.stringify([...values.values()].sort((a, b) => a.localeCompare(b))),
  };
}

export function normalizeAttributeOption(option: unknown): string {
  return String(option ?? '').trim().replace(/\s+/g, ' ');
}
